import {connect} from "react-redux"
import {IncomingHttpHeaders} from "http"
import State from "../../ducks/state"
import {REALM_HEADER} from "../../config/constants"

export const mapStateToProps = (state: State) => {
    const {variant, iconsVersionPath, isTpSuperLite} = state.settings
    const {siteUrl, cleanSiteUrl} = state.request

    return {
        textAlignment: state.textAlignment,
        chevronIconAltText: state.text.catalogueItem.chevronIconAltText,
        siteUrl: isTpSuperLite ? cleanSiteUrl : siteUrl,
        realm: (state.request.headers as IncomingHttpHeaders)[REALM_HEADER] as string,
        rememberSelectedDepartment: state.settings.rememberSelectedDepartment,
        englishDepartment: state.secondarynav.catalogues[state.primarynav.activeDepartment].englishTitle,
        variant,
        iconsVersionPath,
    }
}

export default connect(mapStateToProps)
